import { render, staticRenderFns } from "./profile-container.vue?vue&type=template&id=56bd71b0"
import script from "./profile-container.vue?vue&type=script&lang=js"
export * from "./profile-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports